import data from "../../../../../src/Breadcrumbs/Breadcrumbs.docs.json";
import * as React from 'react';
export default {
  data,
  React
};